import {Product} from '@hconnect/apiclient'

import {useAdminPilotUser} from '../../../common/hooks/useAdminPilotUser'
import {useLoggedInUserPermissions} from '../../../hooks/useLoggedInUser'
import {Permission} from '../../../modules/LoggedInUser'
import {RoleAssignment} from '../../../modules/ManageUsers.selectors'

export const useInvitationProducts = (
  products: Product[],
  loggedInUserPermissions?: Permission[] | null,
  roles?: RoleAssignment[] | null
) => {
  const loggedInUserPermissionsData = useLoggedInUserPermissions(loggedInUserPermissions)

  const isUserAdminPilot = useAdminPilotUser(loggedInUserPermissionsData)
  const canCreateDataLinkDeveloper = loggedInUserPermissionsData.find(
    (permission) => permission.permissionType === 'CREATE_DATALINK_DEVELOPER'
  )
  const isUserInternal = roles?.some((role) => role.isInternal)

  const hideProducts = (product: Product) => {
    return (
      (product === Product.Datalink && !canCreateDataLinkDeveloper) ||
      (product === Product.UserManagement && isUserAdminPilot) ||
      (product === Product.HProduce && !isUserInternal)
    )
  }

  const filteredProducts = products.filter((product) => !hideProducts(product))

  return {
    filteredProducts
  }
}
